import { PrimitiveAutocomplete } from "@src/components/fields/PrimitiveAutocomplete";
import { GQLCameraType } from "@src/graphql.generated";
import { type ReactElement } from "react";
import { type FieldRenderProps } from "react-final-form";

// Labels default to the uppercased enum name; override only where that doesn't match the product name.
// RM4ECO_PLUS would otherwise render as "RM4ECO_PLUS" (the "+" can't live in a GraphQL enum name).
const cameraTypeLabels: Partial<Record<GQLCameraType, string>> = {
    [GQLCameraType.RM4ECO_PLUS]: "RM4eco+",
};

export const CameraTypeSelect = (props: FieldRenderProps<string, HTMLInputElement | HTMLTextAreaElement>): ReactElement => {
    const options = Object.values(GQLCameraType) as string[];

    return (
        <PrimitiveAutocomplete
            {...props}
            options={options}
            getOptionLabel={(type) => cameraTypeLabels[type as GQLCameraType] ?? String(type).toUpperCase()}
        />
    );
};
